/**
 * Servicio para convertir enlaces FAMS a KML
 */
import { apiClient } from './apiClient';

export interface FAMSConvertResponse {
  nombre: string;
  area_hectareas: number;
  num_poligonos: number;
  kml_base64: string;
}

class FAMSService {
  /**
   * Valida si una URL es un enlace válido de FAMS
   */
  isValidFamsUrl(url: string): boolean {
    const pattern = /share\.fams\.app\/v3\/\d{4}-\d{2}-\d{2}\/[a-f0-9-]+/i;
    return pattern.test(url);
  }

  /**
   * Convierte un enlace FAMS a KML y retorna la información
   */
  async convertToKmlInfo(url: string): Promise<FAMSConvertResponse> {
    const response = await apiClient.post<FAMSConvertResponse>('/fams/convert-to-kml-info', { url });
    return response.data;
  }

  /**
   * Descarga el KML directamente como Blob
   */
  async downloadKml(url: string): Promise<{ blob: Blob; filename: string; area: number }> {
    const response = await apiClient.post('/fams/convert-to-kml', { url }, {
      responseType: 'blob'
    });

    // Extraer nombre del archivo del header
    const contentDisposition = response.headers['content-disposition'];
    let filename = 'fams_export.kml';
    if (contentDisposition) {
      const match = contentDisposition.match(/filename="(.+)"/);
      if (match) {
        filename = match[1];
      }
    }

    // Extraer área del header
    const area = parseFloat(response.headers['x-area-hectareas'] || '0');

    return {
      blob: response.data,
      filename,
      area
    };
  }

  /**
   * Convierte el KML base64 a un objeto File
   */
  base64ToFile(base64: string, filename: string): File {
    const binaryString = atob(base64);
    const bytes = new Uint8Array(binaryString.length);
    for (let i = 0; i < binaryString.length; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }
    const blob = new Blob([bytes], { type: 'application/vnd.google-earth.kml+xml' });
    return new File([blob], filename, { type: 'application/vnd.google-earth.kml+xml' });
  }
}

export const famsService = new FAMSService();
export default famsService;
